export const iconFontAwesomeUsersPeopleWheelchair = (
	<i className="fa-solid fa-wheelchair"></i>
);
